import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { PackContents } from './components/PackContents';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { EmotionalClose } from './components/EmotionalClose';
import { FretDivider } from './components/Ornaments';
import { FloatingWhatsApp } from './components/WhatsAppButton';
const TransitionPhrase = () => <div className="mx-auto max-w-3xl px-6 py-6 text-center" data-id="element-0" data-mp="2wiyxuugtfxcq">
    <FretDivider character="次" data-id="element-1" data-mp="28ufqch5lbolp" />
    <p className="mt-4 font-display text-xl font-bold italic leading-relaxed text-brand-cinnabar/90 md:text-3xl" data-id="element-2" data-mp="28tme50nv46w6">
      La próxima sesión puede ser diferente.
    </p>
  </div>;
export function App() {
  return <div className="rice-paper min-h-screen font-sans text-brand-text selection:bg-brand-cinnabar/20 selection:text-brand-cinnabarDark" data-id="element-3" data-mp="3ij64oawq3n8e">
      <UrgencyBanner data-id="element-4" data-mp="3mj6ibtbzzuee" />
      <Hero data-id="element-5" data-mp="3rcj7q5oi4587" />
      <PackContents data-id="element-6" data-mp="3rbrcwx2qabiz" />
      <InitialTestimonials data-id="element-7" data-mp="3rdkisa5iorpx" />
      <PainPoints data-id="element-8" data-mp="3recdzjv7cnfo" />
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-9" data-mp="5yj0slx59ec">
        <Pricing data-id="element-10" data-mp="56m9egl55mh" />
      </div>
      <MoreTestimonials data-id="element-11" data-mp="2zl3c5m4yv85u" />
      <FAQ data-id="element-12" data-mp="2zlv6yuqqp1v2" />
      <TransitionPhrase data-id="element-13" data-mp="2zm4xqkjlzd1t" />
      <EmotionalClose data-id="element-14" data-mp="2zmwguvw0rib7" />
      <Footer data-id="element-15" data-mp="2znfy0adui2o6" />
      <FloatingNotification data-id="element-16" data-mp="33mf0loc3tncg" />
      <FloatingWhatsApp data-id="element-17" data-mp="33nq55qddiz4m" />
    </div>;
}